import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";

export function UnpublishedChangesBanner() {
    return (
        <BTAlert
            data-testid="unpublishedChangesBanner"
            type="info"
            showIcon
            message="Unpublished changes in this spec. People with viewing permissions can access the last published version."
        />
    );
}
